import { render } from "./page-search.vue?vue&type=template&id=4273b731&scoped=true&ts=true"
import script from "./page-search.vue?vue&type=script&lang=ts"
export * from "./page-search.vue?vue&type=script&lang=ts"

import "./page-search.vue?vue&type=style&index=0&id=4273b731&scoped=true&lang=css"

import exportComponent from "/vercel/path2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4273b731"]])

export default __exports__